export default __webpack_public_path__ + "d0d6bd6bb89959c159e749b4c4dedbc5.png";